// --------------------------------------------
// This file is auto-generated by Design2Code.
// Agent: Claude Code
// --------------------------------------------

import React from "react";
import { CloudDatabaseRegular, CloudDatabaseFilled } from "@fluentui/react-icons";
import { TeamAppConfig } from "Apps/TeamAppModel";

const SarcApp = React.lazy(async () => {
    const namedExport = await import("./SarcApp");
    return { default: namedExport.SarcApp };
});

export const Sarc: TeamAppConfig = {
    title: "Substrate on Azure Resource Coordinator",
    regularIcon: CloudDatabaseRegular,
    filledIcon: CloudDatabaseFilled,
    description: "Substrate on Azure Resource Coordinator - Manage provisioning and deallocation requests for Azure resources",
    team: "Fleet Innovation",
    publicId: "SUBSTRATEONAZURERESOURCECOORDINATOR\\Triage",
    owner: "sarcoc@microsoft.com",
    role: "*",
    tags: ["fleet", "sarc", "provisioning", "deallocation", "azure"],
    app: SarcApp,
    path: "/Sarc"
};
